import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, SubscriptionLike } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONFIG } from 'src/helper/app-config';
import { SKUModal } from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { PlanogramService } from 'src/services/planogram.service';
 



interface DialogData{
  sku:any
}

@Component({
  selector: 'app-sku-info-dialog',
  templateUrl: './sku-info-dialog.component.html',
  styleUrls: ['./sku-info-dialog.component.css']
})
export class SkuInfoDialogComponent implements OnInit{
  CONFIG =CONFIG 
  skuInfoImage:string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, 
  private dialogRef: MatDialogRef<SkuInfoDialogComponent>, private planogramState: PlanogramStateService,private apiService:PlanogramService) { }
  

  ngOnInit(): void {
    this.getImage(this.data.sku.sku_image_uri)
  }

  getImage(url:string) {
    this.apiService.fetchImageFromBlob(url).subscribe({
      next: (res: any) => {
        const imageUrl = URL.createObjectURL(res); // Create a URL for the Blob
        this.skuInfoImage=imageUrl;
      },
      error: (error) => {
        console.log('Error fetching image:', error);
      },
    });
  }

  dialogClose(){
    this.dialogRef.close()
  }

}




